<template>
    <div>
        <div class="d-flex" id="wrapper" :class="{ toggled: isSidebar }">
            <app-sidebar></app-sidebar>
            <div id="page-content-wrapper" style="width:100%">
                <i class="material-icons" id="menu-toggle" @click="isSidebar =  !isSidebar" style="cursor:pointer">view_headline</i>
                <app-navbar></app-navbar>
    
                <template>
                    <div class="container-fluid">
                        
                        <iframe
                             id="analytics-iframe"
                             v-if="iframeAllowed"
                             :src="iframeUrl"
                             width="100%"
                             height="1200"
                             frameborder="0"
                           ></iframe>            
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";

export default {
    data: () => ({
        isSidebar: false,
        iframeUrl: 'https://tmisodc.org/certificates/view_certificates.php',
        iframeAllowed: true
        
    }),

    components: {
        "app-navbar": Navbar,
        "app-sidebar": Sidebar
    },
  
   mounted(){
    setTimeout(() => {
        const iframe = document.querySelector('iframe');
        if (iframe && iframe.contentWindow === null) {
          this.iframeAllowed = false;
        }
      }, 1000);
   },
    
  
};
</script>

<style scoped>
.myNavbar {
    color: rgb(255, 255, 255);
}

@media (max-width: 768px) {}


</style>